export const socioIndicators = [
  {
    label: 'Economic well-being',
    secondaryLabel: 'Occupation/Livelihoods',
    children: [
      'Employment rates',
      'Unemployment trends',
      'Livelihood diversity and availability',
      'Sense of employment security',
      'Job satisfaction',
      'Resource-based livelihoods (extractive and non-extractive)',
      'Non-resource based livelihoods',
      'Seasonality'
    ]
  },
  {
    label: 'Economic well-being',
    secondaryLabel: 'Income',
    children: [
      'Income',
      'Affordability',
      'Wages',
      'After-tax income rates',
      'Income per unit fishing effort',
      'Savings'
    ]
  },
  {
    label: 'Economic well-being',
    secondaryLabel: 'Material Wealth',
    children: [
      'Household material assets index',
      'Possessions',
      'Material living standards',
      'Informal economy characteristics (e.g., barter and trade systems)'
    ]
  },
  {
    label: 'Health',
    secondaryLabel: 'Food Security',
    children: [
      'Household or child food security index',
      'Catch per unit effort (for consumption)',
      'Affordability and accessibility of healthful food and clean drinking water',
      'Local fisheries and agriculture harvests',
      'Toxin levels in local shellfish harvest areas'
    ]
  },
  {
    label: 'Health',
    secondaryLabel: 'Mortality',
    children: ['Infant/under 5/adult mortality', 'Death rate']
  },
  {
    label: 'Health',
    secondaryLabel: 'Physical Health',
    children: [
      'Morbidity',
      'Household disease rate/burden',
      'Life expectancy',
      'Birth rate',
      'Access to health care services'
    ]
  },
  {
    label: 'Health',
    secondaryLabel: 'Mental Health',
    children: [
      'Incidence of depression and anxiety',
      'Mental illness',
      'Addiction rates and addiction support services',
      'Mental health outreach services'
    ]
  },
  {
    label: 'Health',
    secondaryLabel: 'Emotional Health',
    children: ['Sense of control', 'Feeling of happiness', 'Overall life satisfaction']
  },
  {
    label: 'Health',
    secondaryLabel: 'Safety and Security',
    children: [
      'Crime rates',
      'Crime severity',
      'Acts of violence',
      'Threats',
      'Emergency services',
      'Safety at sea',
      'Sense of personal security',
      'Sense of community security;'
    ]
  },
  {
    label: 'Political empowerment',
    secondaryLabel: 'Empowerment and Agency',
    children: [
      'Increased power or access to power through collaboration or other processes',
      'Capacity building initiatives',
      'Financial support for bottom-up organizations'
    ]
  },
  {
    label: 'Political empowerment',
    secondaryLabel: 'Resource Rights',
    children: [
      'Change in tenure',
      'Change in property rights: withdrawal, exclusion, alienation, management, access'
    ]
  },
  {
    label: 'Political empowerment',
    secondaryLabel: 'Political/Community Engagement',
    children: [
      'Participation in community groups',
      'Female participation in marine community groups',
      'Financial contribution to marine community groups: voting rates'
    ]
  },
  {
    label: 'Education',
    secondaryLabel: 'Formal Education',
    children: [
      'School enrollment rates',
      'Literacy rates',
      'School attendance & achievement',
      'Cost/ease of access to education and specialized training'
    ]
  },
  {
    label: 'Education',
    secondaryLabel: 'Environment Education',
    children: [
      'Awareness of threats to (marine) environment',
      'Awareness of marine conservation actions',
      'Knowledge of marine environment'
    ]
  },
  {
    label: 'Social capital',
    secondaryLabel: 'Social Capital and Cohesion',
    children: [
      'Trust in neighbors',
      'Sense of community',
      'Community spaces',
      'Conflicts between groups',
      'Trends in social conflict'
    ]
  },
  {
    label: 'Culture',
    secondaryLabel: 'Sense of Place',
    children: [
      'Place attachment',
      'Sense of place',
      'Knowledge of the natural environment',
      'Time spent outdoors',
      'Access to nature',
      'Outdoor activities'
    ]
  },
  {
    label: 'Culture',
    secondaryLabel: 'Cultural Identity',
    children: [
      'Self-definition (at individual and community levels)',
      'Sense of connection to livelihood',
      'Perceptions of one\u2019s culture by others'
    ]
  },
  {
    label: 'Culture',
    secondaryLabel: 'Cultural Diversity',
    children: ['Demography of cultural groups (ethnic, religious, linguistic diversity)']
  },
  {
    label: 'Culture',
    secondaryLabel: 'Traditional Knowledge',
    children: [
      'Use',
      'Preservation',
      'And transfer of traditional ecological knowledge and place names'
    ]
  },
  {
    label: 'Culture',
    secondaryLabel: 'Activities and Practices',
    children: [
      'Participation in cultural practices',
      'Continuity of practices and customs',
      'Traditional use of resources',
      'Traditional management activities',
      'Social organization',
      'Access to sacred sites',
      'Cultural festivals and events'
    ]
  }
]
